module.exports = __webpack_public_path__ + "img/partner1.2e858e91.png";